'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../node_modules/tslib/tslib.es6.js');
var jsxRuntime = require('react/jsx-runtime');

var SvgOilQuart16 = function (_a) {
    var title = _a.title, titleId = _a.titleId, props = tslib_es6.__rest(_a, ["title", "titleId"]);
    return (jsxRuntime.jsxs("svg", tslib_es6.__assign({ width: 16, height: 16, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-labelledby": titleId }, props, { children: [title ? jsxRuntime.jsx("title", tslib_es6.__assign({ id: titleId }, { children: title })) : null, jsxRuntime.jsxs("g", tslib_es6.__assign({ fill: "none", fillRule: "evenodd" }, { children: [jsxRuntime.jsx("path", { fill: "none", d: "M0 .5h16v16H0z" }), jsxRuntime.jsx("path", { d: "M4.45 3.25h2.808v2.119l3.695 2.58c.375.26.598.688.598 1.145v4.097c0 .309-.25.559-.559.559H5.008a.559.559 0 0 1-.559-.559V3.25Zm3.588 4.702a.069.069 0 0 0-.098 0c-.06.065-1.476 1.616-1.476 2.536 0 .944.775 1.509 1.525 1.509.749 0 1.524-.565 1.524-1.509 0-.92-1.415-2.47-1.475-2.536Z", stroke: "currentColor" })] }))] })));
};

exports.default = SvgOilQuart16;
